import React, { useState } from 'react';
import { Label } from './Label';
import { FormField } from './FormField';
import { FormHelperText, makeStyles } from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import { isValidPhoneNumber } from 'libphonenumber-js';
import 'react-phone-input-2/lib/bootstrap.css';
import { Colors } from '../../constants/colors';
import { rgba } from 'polished';

type PhoneFormFieldProps = {
  required: boolean;
  onChangeValue: (value: string) => void;
  disabled?: boolean;
  initialValue?: string;
  formHelperText?: string | false;
  onChangeValid?: (valid: boolean) => void;
}

const useStyles = makeStyles({
  invalid: {
    color: Colors.danger + '!important',
    '&:focus': {
      boxShadow: `0 0 0 0.2rem ${rgba(Colors.danger, 0.25)} !important`,
      borderColor: 'transparent !important'
    }
  }
});

export const PhoneFormField = (props: PhoneFormFieldProps) => {
  const [isValid, setIsValid] = useState<boolean>(true);

  const classes = useStyles();

  const handleValueChange = (value: string) => {
    const isValid = (!props.required && value.length === 0) || isValidPhoneNumber('+' + value);
    props.onChangeValue(isValid ? '+' + value : '');

    if (props.onChangeValid) {
      props.onChangeValid(isValid);
    }

    // Change input class
    setIsValid(isValid);
  };

  return <FormField>
    <Label required={props.required}>Telefonní číslo:</Label>
    <PhoneInput
      inputStyle={{
        border: '1px solid #DEDEDE',
        padding: '0.625rem 1.625rem 0.625rem 3.25rem',
        marginTop: '0.313rem',
        width: '100%'
      }}
      inputClass={isValid ? '' : classes.invalid}
      buttonStyle={{
        marginTop: '0.313rem'
      }}
      country={'cz'}
      preferredCountries={['cz', 'sk']}
      value={props.initialValue ?? ''}
      disabled={props.disabled}
      onChange={e => handleValueChange(e)} />
    {props.disabled && <FormHelperText>
      Ověřené telefonní číslo nelze změnit
    </FormHelperText>}
    {props.formHelperText && <FormHelperText>
      {props.formHelperText}
    </FormHelperText>}
  </FormField>;
};
